import { css } from "../../../styled-system/css";

export const styles = {
  root: () =>
    css({
      aspectRatio: "auto",
      height: "auto",
      maxWidth: "var(--maxWidth, initial)",
    }),
  image: () =>
    css({
      display: "block",
      maxWidth: "100%",
      maxHeight: "100%",
      aspectRatio: "var(--aspectRatio, auto)",
      height: "auto",
      width: "100%",
    }),
};
